import React, { useEffect, useState } from "react";
import { formatDistance, parseISO } from "date-fns";

import {
  getActiveProgramById,
  getIcdCodes,
  getUserSession,
  updateUserSession,
} from "../../services/ActivePrograms";
import { toast } from "react-toastify";
import { IoArrowBack } from "react-icons/io5";
import { AiFillEdit } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { RiDeleteBin6Fill } from "react-icons/ri";
import AsyncSelect from "react-select/async";
import "react-quill/dist/quill.snow.css";

import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import moment from "moment";
import BulletEditor from "../../commonComponent/BulletEditor";
import { Checkbox } from "@mui/material";

const RateChart = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <AreaChart
        data={data}
        margin={{
          top: 10,
          right: 0,
          left: -25,
          bottom: 0,
        }}
      >
        <CartesianGrid
          strokeDasharray="3 1"
          stroke="#999B9C"
          vertical={false}
          horizontal={true}
        />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Area
          type="monotone"
          dataKey="value"
          strokeWidth={3}
          stroke="#4CC2B0"
          fill="#4CC2B0"
          fillOpacity={0.3}
        />
        <Area
          type="monotone"
          dataKey="value2"
          strokeWidth={3}
          stroke="#999B9C"
          fill="#999B9C"
          fillOpacity={0.3}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

const EditChiefComplaintModal = ({
  editComplaint,
  handleEditChiefComplaint,
}) => {
  const [chiefComplaint, setChiefComplaint] = useState({
    complaints: "",
    duration: "",
    frequency: "Days",
  });

  useEffect(() => {
    setChiefComplaint({
      complaints: editComplaint?.complaints ?? "",
      duration: editComplaint?.duration ?? "",
      frequency: editComplaint?.frequency ?? "",
    });
  }, [editComplaint]);

  const handleChange = (e) => {
    setChiefComplaint((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditChiefComplaint(editComplaint.index, chiefComplaint);
    setChiefComplaint({
      complaints: "",
      duration: "",
      frequency: "Days",
    });
    document.getElementById("closeEditChiefComplaintModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editChiefComplaintModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
            <h5 className="mb-0">Chief Complaint</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditChiefComplaintModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-7">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Complaint
                  </label>
                </div>
                <div className="col-md-5">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Duration
                  </label>
                </div>
                <div className="col-md-7 mt-3">
                  <input
                    type="text"
                    name="complaints"
                    required
                    className="form-control bg-light"
                    placeholder="Complaint"
                    onInput={handleChange}
                    value={chiefComplaint.complaints}
                  />
                </div>
                <div className="col-md-5 mt-3">
                  <div className="d-flex gap-4">
                    <input
                      type="number"
                      name="duration"
                      id="duration"
                      required
                      className="form-control bg-light"
                      onInput={handleChange}
                      value={chiefComplaint.duration}
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      required
                      className="form-select bg-light"
                      onChange={handleChange}
                      value={chiefComplaint.frequency}
                    >
                      <option value="Days">Days</option>
                      <option value="Weeks">Weeks</option>
                      <option value="Months">Months</option>
                      <option value="Years">Years</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white"
                >
                  Update Complaint
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddChiefComplaintModal = ({ handleAddChiefComplaint }) => {
  const [chiefComplaint, setChiefComplaint] = useState({
    complaints: "",
    duration: "",
    frequency: "Days",
  });

  const handleChange = (e) => {
    setChiefComplaint((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddChiefComplaint(chiefComplaint);
    setChiefComplaint({
      complaints: "",
      duration: "",
      frequency: "Days",
    });
    document.getElementById("closeAddChiefComplaintModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addChiefComplaintModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            {/* <h5 className="modal-title" id="exampleModalLabel">Modal title</h5> */}
            <h5 className="mb-0">Chief Complaint</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddChiefComplaintModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-7">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Complaint
                  </label>
                </div>
                <div className="col-md-5">
                  <label
                    htmlFor="chiefComplaint"
                    className="form-label text-green fw-bold"
                  >
                    Duration
                  </label>
                </div>
                <div className="col-md-7 mt-3">
                  <input
                    type="text"
                    name="complaints"
                    className="form-control bg-light"
                    placeholder="Complaint"
                    onInput={handleChange}
                    value={chiefComplaint.complaints}
                    required
                  />
                </div>
                <div className="col-md-5 mt-3">
                  <div className="d-flex gap-4">
                    <input
                      type="number"
                      name="duration"
                      id="duration"
                      className="form-control bg-light"
                      onInput={handleChange}
                      value={chiefComplaint.duration}
                      required
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      onChange={handleChange}
                      value={chiefComplaint.frequency}
                      required
                    >
                      <option value="Days">Days</option>
                      <option value="Weeks">Weeks</option>
                      <option value="Months">Months</option>
                      <option value="Years">Years</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white"
                >
                  Add Complaint
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddCarePlanModal = ({ handleAddCarePlan, carePlanList }) => {
  const [carePlan, setCarePlan] = useState({ _id: "", name: "" });
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddCarePlan(carePlan);
    setCarePlan({ _id: "", name: "" });
    document.getElementById("closeAddCarePlanModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addCarePlanModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Care Plans</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddCarePlanModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <select
                    name="duration"
                    id="duration"
                    className="form-select bg-light"
                    onChange={(e) =>
                      setCarePlan({
                        _id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      })
                    }
                    value={carePlan?._id}
                    required
                  >
                    <option value="">Select Care Plan</option>
                    {carePlanList.map((item, index) => (
                      <option value={item._id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Add Care Plan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditMedicalHistoryModal = ({
  editMedicalHistory,
  handleEditMedicalHistory,
}) => {
  const [medicalHistory, setMedicalHistory] = useState(editMedicalHistory);
  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditMedicalHistory(editMedicalHistory.index, medicalHistory);
    setMedicalHistory({ _id: "", name: "", duration: "", frequency: "" });
    document.getElementById("closeEditMedicalHistoryModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editMedicalHistoryModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Medical History</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditMedicalHistoryModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Medical Condition"
                    value={medicalHistory?.name}
                    onInput={(e) =>
                      setMedicalHistory({
                        ...medicalHistory,
                        medicalCondition: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <div className="d-flex gap-3 align-items-center">
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="Enter Duration"
                      value={medicalHistory?.duration}
                      onInput={(e) =>
                        setMedicalHistory({
                          ...medicalHistory,
                          duration: e.target.value,
                        })
                      }
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      value={medicalHistory?.frequency}
                      onChange={(e) =>
                        setMedicalHistory({
                          ...medicalHistory,
                          frequency: e.target.value,
                        })
                      }
                    >
                      <option value="years">Years</option>
                      <option value="months">Months</option>
                      <option value="weeks">Weeks</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Update Medical History
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddMedicalHistoryModal = ({ handleAddMedicalHistory }) => {
  const [medicalHistory, setMedicalHistory] = useState({
    medicalCondition: "",
    duration: "",
    frequency: "years",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddMedicalHistory(medicalHistory);
    setMedicalHistory({
      medicalCondition: "",
      duration: "",
      frequency: "years",
    });
    document.getElementById("closeAddMedicalHistoryModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addMedicalHistoryModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Medical History</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddMedicalHistoryModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Medical Condition"
                    value={medicalHistory?.medicalCondition}
                    onInput={(e) =>
                      setMedicalHistory({
                        ...medicalHistory,
                        medicalCondition: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <div className="d-flex gap-3 align-items-center">
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="Enter Duration"
                      value={medicalHistory?.duration}
                      onInput={(e) =>
                        setMedicalHistory({
                          ...medicalHistory,
                          duration: e.target.value,
                        })
                      }
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      onChange={(e) =>
                        setMedicalHistory({
                          ...medicalHistory,
                          frequency: e.target.value,
                        })
                      }
                      value={medicalHistory?.frequency}
                    >
                      <option value="years">Years</option>
                      <option value="months">Months</option>
                      <option value="weeks">Weeks</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Add Medical History
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditFamilySocialHistoryModal = ({
  editFamilySocialHistory,
  handleEditFamilySocialHistory,
}) => {
  const [familySocialHistory, setFamilySocialHistory] = useState(
    editFamilySocialHistory
  );
  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditFamilySocialHistory(
      editFamilySocialHistory.index,
      familySocialHistory
    );
    document.getElementById("closeEditFamilySocialHistoryModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editFamilySocialHistoryModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Family Social History</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditFamilySocialHistoryModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Relation"
                    value={familySocialHistory?.relation}
                    onInput={(e) =>
                      setFamilySocialHistory({
                        ...familySocialHistory,
                        relation: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <div className="d-flex gap-3 align-items-center">
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="Enter Duration"
                      value={familySocialHistory?.duration}
                      onInput={(e) =>
                        setFamilySocialHistory({
                          ...familySocialHistory,
                          duration: e.target.value,
                        })
                      }
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      value={familySocialHistory?.frequency}
                      onChange={(e) =>
                        setFamilySocialHistory({
                          ...familySocialHistory,
                          frequency: e.target.value,
                        })
                      }
                    >
                      <option value="years">Years</option>
                      <option value="months">Months</option>
                      <option value="weeks">Weeks</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Update Family Social History
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const AddFamilySocialHistoryModal = ({ handleAddFamilySocialHistory }) => {
  const [familySocialHistory, setFamilySocialHistory] = useState({
    relation: "",
    medicalCondition: "",
    duration: "",
    frequency: "years",
    causeOfDeath: "",
  });
  const handleSubmit = (e) => {
    e.preventDefault();
    handleAddFamilySocialHistory(familySocialHistory);
    setFamilySocialHistory({
      relation: "",
      medicalCondition: "",
      duration: "",
      frequency: "years",
      causeOfDeath: "",
    });
    document.getElementById("closeAddFamilySocialHistoryModal").click();
  };

  return (
    <div
      className="modal fade"
      id="addFamilySocialHistoryModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Family Social History</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeAddFamilySocialHistoryModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <label className="text-green" htmlFor="relation">
                    Relation
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Relation"
                    value={familySocialHistory?.relation}
                    onInput={(e) =>
                      setFamilySocialHistory({
                        ...familySocialHistory,
                        relation: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <label className="text-green" htmlFor="duration">
                    Disease Condition
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Disease Condition"
                    value={familySocialHistory?.medicalCondition}
                    onInput={(e) =>
                      setFamilySocialHistory({
                        ...familySocialHistory,
                        medicalCondition: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <label className="text-green" htmlFor="duration">
                    Duration
                  </label>
                  <div className="d-flex gap-3 align-items-center">
                    <input
                      type="number"
                      className="form-control bg-light"
                      placeholder="Enter Duration"
                      value={familySocialHistory?.duration}
                      onInput={(e) =>
                        setFamilySocialHistory({
                          ...familySocialHistory,
                          duration: e.target.value,
                        })
                      }
                    />
                    <select
                      name="frequency"
                      id="frequency"
                      className="form-select bg-light"
                      onChange={(e) =>
                        setFamilySocialHistory({
                          ...familySocialHistory,
                          frequency: e.target.value,
                        })
                      }
                      value={familySocialHistory?.frequency}
                    >
                      <option value="years">Years</option>
                      <option value="months">Months</option>
                      <option value="weeks">Weeks</option>
                      <option value="days">Days</option>
                    </select>
                  </div>
                </div>
                <div className="col-md-12 mt-3">
                  <label className="text-green" htmlFor="duration">
                    Cause of Death
                  </label>
                  <input
                    type="text"
                    className="form-control bg-light"
                    placeholder="Enter Cause of Death"
                    value={familySocialHistory?.causeOfDeath}
                    onInput={(e) =>
                      setFamilySocialHistory({
                        ...familySocialHistory,
                        causeOfDeath: e.target.value,
                      })
                    }
                  />
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Add Family Social History
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const EditCarePlanModal = ({
  editCarePlan,
  handleEditCarePlan,
  carePlanList,
}) => {
  const [carePlan, setCarePlan] = useState("");
  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditCarePlan(editCarePlan.index, carePlan);
    setCarePlan("");
    document.getElementById("closeEditCarePlanModal").click();
  };

  return (
    <div
      className="modal fade"
      id="editCarePlanModal"
      aria-labelledby="memberModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header p-4 border-0">
            <h5 className="mb-0">Care Plans</h5>
            <button
              type="button"
              className="btn-close border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="closeEditCarePlanModal"
            ></button>
          </div>
          <div className="modal-body pb-4 px-4">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <select
                    name="duration"
                    id="duration"
                    className="form-select bg-light"
                    onChange={(e) =>
                      setCarePlan({
                        _id: e.target.value,
                        name: e.target.options[e.target.selectedIndex].text,
                      })
                    }
                    value={editCarePlan?.carePlan?._id}
                    required
                  >
                    <option value="">Select Care Plan</option>
                    {carePlanList.map((item, index) => (
                      <option value={item._id} key={index}>
                        {item.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-5">
                <button
                  type="submit"
                  className="btn w-100  btn-custom text-white "
                >
                  Update Care Plan
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

// export default BulletTextEditor;
const defineMedicalHistory = ["Hypertension", "Obesity", "Asthma", "Diabetes"];
function ViewSessionNoteEdit({ setViewMode, state, member, notes }) {
  const [ProgramDetails, setProgramDetails] = useState({});
  const [editComplaint, setEditComplaint] = useState(null);
  const [editCarePlan, setEditCarePlan] = useState(null);
  const [editMedicalHistory, setEditMedicalHistory] = useState(null);
  const [editFamilySocialHistory, setEditFamilySocialHistory] = useState(null);
  const [chiefComplaint, setChiefComplaint] = useState([]);
  const [carePlanList, setCarePlanList] = useState([]);
  const [carePlans, setCarePlans] = useState([]);
  const [historyOfPresentIllness, setHistoryOfPresentIllness] = useState("");
  const [reviewOfSystems, setReviewOfSystems] = useState("");
  const [bloodPressure, setBloodPressure] = useState({
    systolic: "",
    diastolic: "",
  });
  const [respiratory, setRespiratory] = useState("");
  const [temperature, setTemperature] = useState("");
  const [oxygenSaturation, setOxygenSaturation] = useState("");
  const [heartRate, setHeartRate] = useState("");
  const [otherSystemComments, setOtherSystemComments] = useState("");
  const [assessmentDiagnosis, setAssessmentDiagnosis] = useState("");
  const [assessmentComments, setAssessmentComments] = useState("");
  const [carePlanComments, setCarePlanComments] = useState("");
  const [familySocialHistory, setFamilySocialHistory] = useState([]);
  const [medicalHistory, setMedicalHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [familyMedicalHistory, setFamilyMedicalHistory] = useState({
    smoking: "",
    alcohol: "",
    exercise: "",
    comments: "",
  });
  const [medicalHistoryComments, setMedicalHistoryComments] = useState("");

  const [duration, setDuration] = useState("");
  const [icdCodeList, setIcdCodeList] = useState([]);
  const [session, setSession] = useState(null);

  const [respiratoryHistory, setRespiratoryHistory] = useState([]);
  const [temperatureHistory, setTemperatureHistory] = useState([]);
  const [bloodPressureHistory, setBloodPressureHistory] = useState([]);
  const [oxygenSaturationHistory, setOxygenSaturationHistory] = useState([]);
  const [heartRateHistory, setHeartRateHistory] = useState([]);
  const [riskProfile, setRiskProfile] = useState(null);

  const getProgram = async () => {
    try {
      const res = await getActiveProgramById(state?.programId);
      setProgramDetails(res?.data?.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const getSession = async () => {
    try {
      const res = await getUserSession(
        state?._id,
        state?.programId,
        member?.user_id
      );
      if (res?.data?.data?.userAssesment[0]?.totalScore <= 120) {
        setRiskProfile(1)
      } else if (res?.data?.data?.userAssesment[0]?.totalScore > 120 && res?.data?.data?.userAssesment[0]?.totalScore <= 240) {
        setRiskProfile(2)
      } else if (res?.data?.data?.userAssesment[0]?.totalScore > 240 && res?.data?.data?.userAssesment[0]?.totalScore <= 360) {
        setRiskProfile(3)
      } else {
        setRiskProfile(0)
      }

      setSession(res?.data?.data);
      setIcdCodeList(res?.data?.data?.icdCodeList);
      setCarePlanList(res?.data?.data?.carePlanList);
      if (res?.data?.data?.userSession) {
        const vitals = res?.data?.data?.vitals;
        const userSession = res?.data?.data?.userSession;
        setChiefComplaint(userSession?.chiefComplaints);
        setCarePlans(userSession?.carePlans);
        setHistoryOfPresentIllness(userSession?.historyOfPresentIllness ?? "");
        setReviewOfSystems(userSession?.reviewOfSystems ?? "");
        setOtherSystemComments(userSession?.otherSystemComments ?? "");
        setAssessmentDiagnosis(userSession?.assessmentDiagnosis ?? "");
        setAssessmentComments(userSession?.assessmentComments ?? "");
        setCarePlanComments(userSession?.carePlanComments ?? "");

        setFamilyMedicalHistory({
          smoking: userSession?.familyMedicalHistory?.smoking ?? "",
          alcohol: userSession?.familyMedicalHistory?.alcohol ?? "",
          exercise: userSession?.familyMedicalHistory?.exercise ?? "",
          comments: userSession?.familyMedicalHistory?.comments ?? "",
        });
        setMedicalHistory(userSession?.pastMedicalHistory ?? []);
        setMedicalHistoryComments(userSession?.medicalHistoryComments ?? "");
        setFamilySocialHistory(
          userSession?.familyMedicalHistory?.history ?? []
        );

        if(!userSession?.respiratoryRate){
          setRespiratory(vitals[vitals.length-1]?.respRate);
        }
        else{
          setRespiratory(userSession?.respiratoryRate);
        }
        if(!userSession?.temperature){
          setTemperature(vitals[vitals.length-1]?.bodyTemp);
        }
        else{
          setTemperature(userSession?.temperature);
        }
        if(!userSession?.oxygenSaturation){
          setOxygenSaturation(vitals[vitals.length-1]?.bloodO2);
        }
        else{
          setOxygenSaturation(userSession?.oxygenSaturation);
        }
        if(!userSession?.heartRate){
          setHeartRate(vitals[vitals.length-1]?.heartRate);
        }
        else{
          setHeartRate(userSession?.heartRate);
        }
        if(!userSession?.bloodPressure){
          setBloodPressure({
            systolic: vitals[vitals.length-1]?.bloodBP.split("/")[0],
            diastolic: vitals[vitals.length-1]?.bloodBP.split("/")[1],
          });
        }
        else{
          setBloodPressure(userSession?.bloodPressure);
        }
        setRespiratoryHistory(
          res?.data?.data?.vitals.map((item) => ({
            name: moment(item.createdAt).format("DD MMM YYYY"),
            value: item.respRate,
          }))
        );
        setTemperatureHistory(
          res?.data?.data?.vitals.map((item) => ({
            name: moment(item.createdAt).format("DD MMM YYYY"),
            value: item.bodyTemp,
          }))
        );
        setBloodPressureHistory(
          res?.data?.data?.vitals.map((item) => ({
            name: moment(item.createdAt).format("DD MMM YYYY"),
            value: item.bloodBP.split("/")[0],
            value2: item.bloodBP.split("/")[1],
          }))
        );
        setOxygenSaturationHistory(
          res?.data?.data?.vitals.map((item) => ({
            name: moment(item.createdAt).format("DD MMM YYYY"),
            value: item.bloodO2,
          }))
        );
        setHeartRateHistory(
          res?.data?.data?.vitals.map((item) => ({
            name: moment(item.createdAt).format("DD MMM YYYY"),
            value: item.heartRate,
          }))
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getProgram();
    getSession();
  }, []);

  const handleSubmit = async (type) => {
    let parms = {};
    parms["programId"] = state?.programId;
    parms["sessionId"] = state?._id;
    parms["userId"] = member?.user_id;

    parms["historyOfPresentIllness"] = historyOfPresentIllness;

    parms["reviewOfSystems"] = reviewOfSystems;
    parms["bloodPressure"] = bloodPressure;
    parms["respiratoryRate"] = respiratory;
    parms["temperature"] = temperature;
    parms["oxygenSaturation"] = oxygenSaturation;
    parms["heartRate"] = heartRate;
    parms["otherSystemComments"] = otherSystemComments;
    parms["assessmentDiagnosis"] = assessmentDiagnosis;
    parms["assessmentComments"] = assessmentComments;
    parms["carePlans"] = carePlans.map((item) => item._id);
    parms["chiefComplaints"] = chiefComplaint;
    parms["pastMedicalHistory"] = medicalHistory;
    parms["medicalHistoryComments"] = medicalHistoryComments;
    parms["carePlanComments"] = carePlanComments;
    parms["familyMedicalHistory"] = {
      history: familySocialHistory,
      ...familyMedicalHistory,
    };

    if (type === "saveLater") {
      parms["status"] = "draft";
    } else {
      parms["status"] = "completed";
    }
    try {
      const response = await updateUserSession(parms);
      if (response.status === 200) {
        toast.success("Session Updated");
        setViewMode("sessionNotes");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddChiefComplaint = (data) => {
    setChiefComplaint((prev) => [...prev, data]);
  };
  const handleEditChiefComplaint = (index, data) => {
    setChiefComplaint((prev) =>
      prev.map((item, i) => (i === index ? data : item))
    );
  };
  const handleDeleteChiefComplaint = (index) => {
    setChiefComplaint((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCarePlan = (data) => {
    setCarePlans((prev) => [...prev, data]);
  };
  const handleEditCarePlan = (index, data) => {
    setCarePlans((prev) => prev.map((item, i) => (i === index ? data : item)));
  };
  const handleDeleteCarePlan = (index) => {
    setCarePlans((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddMedicalHistory = (data) => {
    setMedicalHistory((prev) => [...prev, data]);
  };
  const handleEditMedicalHistory = (index, data) => {
    setMedicalHistory((prev) =>
      prev.map((item, i) => (i === index ? data : item))
    );
  };
  const handleDeleteMedicalHistory = (index) => {
    setMedicalHistory((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFamilySocialHistory = (data) => {
    setFamilySocialHistory((prev) => [...prev, data]);
  };
  const handleEditFamilySocialHistory = (index, data) => {
    setFamilySocialHistory((prev) =>
      prev.map((item, i) => (i === index ? data : item))
    );
  };
  const handleDeleteFamilySocialHistory = (index) => {
    setFamilySocialHistory((prev) => prev.filter((_, i) => i !== index));
  };

  const getDuration = () => {
    const dur =
      state?.startTime &&
      state?.endTime &&
      formatDistance(parseISO(state.endTime), parseISO(state.startTime));
    setDuration(dur);
  };
  useEffect(() => {
    getDuration();
  }, []);

  return (
    <div className="row column-gap-5">
      <div className="d-flex mt-2">
        <button
          className="btn btn-primary btn-custom-tag py-2 "
          onClick={() => setViewMode("sessionNotes")}
        >
          <IoArrowBack /> &nbsp;&nbsp;&nbsp; Back
        </button>
      </div>
      <div className="mt-4">
        <h5 className="fw-bold"> Individual Session Note</h5>
      </div>
      {isLoading ? (
        <center>
          <div
            style={{ width: "3rem", height: "3rem", color: "#1f7e78" }}
            class="spinner-border mt-3 mb-4"
            role="status"
          />
        </center>
      ) : (
        <div>
          <div className="mt-4">
            <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
              <h6 className="text-green mb-0 fw-bold">
                Name{" "}
                <span className="text-dark ms-3">
                  {session?.user[0]?.full_name}
                </span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Age{" "}
                <span className="text-dark ms-3">
                  {moment().diff(new Date(session?.user[0]?.dob), "years")}{" "}
                  Years
                </span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Gender{" "}
                <span className="text-dark ms-3">
                  {session?.user[0]?.gender}
                </span>
              </h6>
            </div>
            <div className="d-flex gap-2 align-items-center mt-4 justify-content-between">
              <h6 className="text-green mb-0 fw-bold">
                Encounter type{" "}
                <span className="text-dark ms-3">{session?.session.title}</span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Encounter Date{" "}
                <span className="text-dark ms-3">
                  {moment(session?.session.sessionDate).format("DD MMMM, YYYY")}
                </span>
              </h6>
              <h6 className="text-green mb-0 fw-bold">
                Duration{" "}
                <span className="text-dark ms-3">
                  {
                    Math.floor((new Date(session?.session?.endTime) - new Date(session?.session?.startTime)) / 60000)+" minutes"
                  }
                </span>
              </h6>
            </div>
            <div className="d-flex gap-2 align-items-center mt-4">
              <h6 className="text-green mb-0 fw-bold">Health Risk </h6>
              {riskProfile == 0 ?<h6 className="mb-0 ms-3  ">None</h6>:<h6 className="mb-0 rounded-pill px-3 py-1 ms-3 green-pill ">
              {
                riskProfile == 1 ?
                  "Mild Risk" :
                  riskProfile == 2 ?
                    "Moderate Risk" : riskProfile == 3 ?
                      "High Risk" : "None"
                      }
              </h6>}

              
            </div>
            <div className="d-flex gap-2 align-items-center mt-4">
              <h6 className="text-green mb-0 fw-bold">Allergies </h6>
              {session?.userSession?.allergies?.length > 0 ? (
                session?.userSession?.allergies?.map((item, index) => (
                  <h6
                    className="mb-0 rounded-pill px-3 py-1 ms-3 green-pill "
                    key={index}
                  >
                    {item}
                  </h6>
                ))
              ) : (
                <h6 className="mb-0 ms-3 fw-bold ">None</h6>
              )}
            </div>
            <div className="d-flex gap-2 align-items-center mt-4 ">
              <h6 className="text-green mb-0 fw-bold">Current Medications</h6>
              {session?.userSession?.medications?.length > 0 ? (
                session?.userSession?.medications?.map((item, index) => (
                  <h6
                    className="mb-0 rounded-pill px-3 py-1 ms-3 green-pill fw-bold"
                    key={index}
                  >
                    {item?.name}
                  </h6>
                ))
              ) : (
                <h6 className="mb-0 ms-3 fw-bold ">None</h6>
              )}
            </div>
          </div>

          <div className="mt-1 pt-2">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Subjective</h6>
            </div>
            <div>
              <div className="d-flex gap-3 mt-3 w-100">
                <h6 className="text-green mb-0 text-nowrap fw-bold">
                  Chief Complaints
                </h6>
                <div className="w-100">
                  {chiefComplaint.map((item, index) => (
                    <div
                      className="d-flex gap-3 align-items-center mb-2"
                      key={index}
                    >
                      <input
                        type="text"
                        className="form-control bg-light border-0"
                        placeholder="Add Complaints"
                        value={item.complaints}
                        disabled
                      />
                      <h6 className="text-green mb-0 fw-bold">Duration</h6>
                      <input
                        type="text"
                        className="form-control bg-light w-25 border-0"
                        placeholder="Add Duration"
                        value={item.duration + " " + item.frequency}
                        disabled
                      />
                      <div className="d-flex gap-1 align-items-center">
                        <button
                          className="btn btn-sm"
                          onClick={() => {
                            setEditComplaint({ ...item, index });
                          }}
                          data-bs-toggle="modal"
                          data-bs-target="#editChiefComplaintModal"
                        >
                          <AiFillEdit color="#1F7E78" size={18} />
                        </button>
                        <button
                          className="btn btn-sm"
                          onClick={() => handleDeleteChiefComplaint(index)}
                        >
                          <RiDeleteBin6Fill color="#1F7E78" size={18} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div
                data-bs-toggle="modal"
                data-bs-target="#addChiefComplaintModal"
                className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
                onClick={() => {}}
              >
                <FiPlusCircle color="#1F7E78" size={18} />
                <span
                  href=""
                  className="fst-italic"
                  style={{ fontSize: "16px" }}
                >
                  Add Complaints
                </span>
              </div>
            </div>
          </div>
          <div className="mt-1 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                History of Present Illness
              </span>
            </div>
            <div className="mt-2">
              <BulletEditor
                value={historyOfPresentIllness}
                setValue={setHistoryOfPresentIllness}
              />
            </div>
          </div>
          <div className="mt-2 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                Medical History
              </span>
            </div>
            <div className="mt-2">
              <div className="d-flex gap-3 mt-2 w-100">
                <div className="w-100 row">
                  {defineMedicalHistory.map((item, index) => (
                    <div className="col-md-6 p-0">
                      <div
                        className="row m-0 p-0 align-items-center mb-2"
                        key={index}
                      >
                        <label className="text-green mb-0 col-6 d-flex gap-2 align-items-center">
                          <Checkbox
                            checked={medicalHistory.some(
                              (item1) => item1.medicalCondition === item
                            )}
                            size="small"
                            sx={{
                              padding: "0px",
                              color: "rgba(31, 126, 120, 1)",
                              "&.Mui-checked": {
                                color: "rgba(31, 126, 120, 1)",
                              },
                            }}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setMedicalHistory((prev) => [
                                  ...prev,
                                  {
                                    medicalCondition: item,
                                    duration: "",
                                    frequency: "years",
                                  },
                                ]);
                              } else {
                                setMedicalHistory((prev) =>
                                  prev.filter(
                                    (item1) => item1.medicalCondition !== item
                                  )
                                );
                              }
                            }}
                          />
                          {item}
                        </label>
                        <div className="col-6 d-flex gap-3 align-items-center">
                          <input
                            type="number"
                            className="form-control bg-light"
                            value={
                              medicalHistory.find(
                                (item1) => item1.medicalCondition === item
                              )?.duration
                            }
                            disabled={
                              !medicalHistory.find(
                                (item1) => item1.medicalCondition === item
                              )
                            }
                            style={{ width: "60px" }}
                            onInput={(e) => {
                              setMedicalHistory((prev) =>
                                prev.map((item1) =>
                                  item1.medicalCondition === item
                                    ? { ...item1, duration: e.target.value }
                                    : item1
                                )
                              );
                            }}
                          />
                          <h6 className="mb-0">
                            {medicalHistory.find(
                              (item) => item.medicalCondition === item
                            )?.frequency ?? "years"}
                          </h6>
                        </div>
                      </div>
                    </div>
                  ))}
                  {medicalHistory
                    .filter(
                      (item) =>
                        !defineMedicalHistory.includes(item.medicalCondition)
                    )
                    .map((item, index) => (
                      <div className="col-md-6 p-0">
                        <div
                          className="row m-0 p-0 align-items-center mb-2"
                          key={index}
                        >
                          <label className="text-green mb-0 col-6 d-flex gap-2 align-items-center">
                            <input
                              type="text"
                              className="form-control bg-light"
                              value={item.medicalCondition}
                              onInput={(e) => {
                                setMedicalHistory((prev) =>
                                  prev.map((item1) =>
                                    item1.medicalCondition ===
                                    item.medicalCondition
                                      ? {
                                          ...item1,
                                          medicalCondition: e.target.value,
                                        }
                                      : item1
                                  )
                                );
                              }}
                            />
                          </label>
                          <div className="col-6 d-flex gap-3 align-items-center">
                            <input
                              type="number"
                              className="form-control bg-light"
                              value={item.duration}
                              onInput={(e) => {
                                setMedicalHistory((prev) =>
                                  prev.map((item1) =>
                                    item1.medicalCondition ===
                                    item.medicalCondition
                                      ? { ...item1, duration: e.target.value }
                                      : item1
                                  )
                                );
                              }}
                              style={{ width: "60px" }}
                            />
                            <h6 className="mb-0">
                              {item.frequency ?? "years"}
                            </h6>
                          </div>
                          {/* <div className="d-flex gap-1 align-items-center">
                      <button
                        className="btn btn-sm"
                        onClick={() => {
                          setEditMedicalHistory({ ...item, index });
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#editMedicalHistoryModal"
                      >
                        <AiFillEdit color="#1F7E78" size={18} />
                      </button>
                      <button
                        className="btn btn-sm"
                        onClick={() => handleDeleteMedicalHistory(index)}
                      >
                        <RiDeleteBin6Fill color="#1F7E78" size={18} />
                      </button>
                    </div> */}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
              <div
                data-bs-toggle="modal"
                data-bs-target="#addMedicalHistoryModal"
                className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
              >
                <FiPlusCircle color="#1F7E78" size={18} />
                <span
                  href=""
                  className="fst-italic"
                  style={{ fontSize: "16px" }}
                >
                  Add New Entry
                </span>
              </div>
              <div className="mt-3">
                <BulletEditor
                  value={medicalHistoryComments}
                  setValue={setMedicalHistoryComments}
                  placeholder="Add Comments"
                />
              </div>
            </div>
          </div>
          <div className="mt-2 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                Family & Social History
              </span>
            </div>
            <div className="mt-2">
              <div className="d-flex gap-3 mt-2 w-100">
                <div className="w-100 row">
                  {familySocialHistory.map((item, index) => (
                    <div
                      className="d-flex gap-3 align-items-center mb-2"
                      key={index}
                    >
                      <label className="text-green mb-0 d-flex gap-2 align-items-center text-nowrap">
                        Relationship to you
                        <input
                          type="text"
                          className="form-control bg-light"
                          value={item.relation}
                          disabled
                        />
                      </label>
                      <label className="text-green mb-0 d-flex gap-2 align-items-center text-nowrap">
                        Disease Condition
                        <input
                          type="text"
                          className="form-control bg-light"
                          value={item.medicalCondition}
                          disabled
                        />
                      </label>
                      <label className="text-green mb-0 d-flex gap-2 align-items-center text-nowrap">
                        Duration
                        <input
                          type="text"
                          className="form-control bg-light"
                          style={{ width: "60px" }}
                          value={item.duration}
                          disabled
                        />
                        <span className="mb-0 text-black">
                          {item.frequency}
                        </span>
                      </label>
                      <label className="text-green mb-0 d-flex gap-2 align-items-center text-nowrap">
                        Cause of Death
                        <input
                          type="text"
                          className="form-control bg-light"
                          value={item.causeOfDeath}
                          disabled
                        />
                      </label>
                      <div className="d-flex gap-1 align-items-center">
                        <button
                          className="btn btn-sm"
                          onClick={() => handleDeleteFamilySocialHistory(index)}
                        >
                          <RiDeleteBin6Fill color="#1F7E78" size={18} />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                data-bs-toggle="modal"
                data-bs-target="#addFamilySocialHistoryModal"
                className="d-flex justify-content-start gap-2 align-items-center pointer my-2"
              >
                <FiPlusCircle color="#1F7E78" size={18} />
                <span
                  href=""
                  className="fst-italic"
                  style={{ fontSize: "16px" }}
                >
                  Add New Entry
                </span>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label className="mb-0 d-flex gap-2 align-items-center text-nowrap">
                    Smoking
                    <select
                      name=""
                      id=""
                      value={familyMedicalHistory.smoking}
                      onChange={(e) =>
                        setFamilyMedicalHistory({
                          ...familyMedicalHistory,
                          smoking: e.target.value,
                        })
                      }
                      className="form-select bg-light"
                    >
                      <option value="">Select Smoking</option>
                      <option value="Rarely">Rarely</option>
                      <option value="Sometimes">Sometimes</option>
                      <option value="Often">Often</option>
                      <option value="Everyday">Everyday</option>
                    </select>
                  </label>
                </div>
                <div className="col-md-4">
                  <label className="mb-0 d-flex gap-2 align-items-center text-nowrap">
                    Alcohol
                    <select
                      name=""
                      id=""
                      value={familyMedicalHistory.alcohol}
                      onChange={(e) =>
                        setFamilyMedicalHistory({
                          ...familyMedicalHistory,
                          alcohol: e.target.value,
                        })
                      }
                      className="form-select bg-light"
                    >
                      <option value="">Select Alcohol</option>
                      <option value="Rarely">Rarely</option>
                      <option value="Sometimes">Sometimes</option>
                      <option value="Often">Often</option>
                      <option value="Everyday">Everyday</option>
                    </select>
                  </label>{" "}
                </div>
                <div className="col-md-4">
                  {" "}
                  <label className="mb-0 d-flex gap-2 align-items-center text-nowrap">
                    Exercise
                    <select
                      name=""
                      id=""
                      value={familyMedicalHistory.exercise}
                      onChange={(e) =>
                        setFamilyMedicalHistory({
                          ...familyMedicalHistory,
                          exercise: e.target.value,
                        })
                      }
                      className="form-select bg-light"
                    >
                      <option value="">Select Exercise</option>
                      <option value="Rarely">Rarely</option>
                      <option value="Sometimes">Sometimes</option>
                      <option value="Often">Often</option>
                      <option value="Everyday">Everyday</option>
                    </select>
                  </label>{" "}
                </div>
              </div>
              <div className="mt-3">
                <BulletEditor
                  value={familyMedicalHistory.comments}
                  setValue={(e) =>
                    setFamilyMedicalHistory({
                      ...familyMedicalHistory,
                      comments: e,
                    })
                  }
                  placeholder="Add Comments"
                />
              </div>
            </div>
          </div>
          <div className="mt-2 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                Review of Systems
              </span>
            </div>
            <div className="mt-2">
              <BulletEditor
                value={reviewOfSystems}
                setValue={setReviewOfSystems}
              />
            </div>
          </div>

          <div className="mt-3">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Objective</h6>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 px-3">
                <h6 className=" text-muted mb-0">Blood Pressure</h6>
                <div className="d-flex gap-2 align-items-center my-2 ">
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={bloodPressure?.systolic}
                    onChange={(e) =>
                      setBloodPressure({
                        ...bloodPressure,
                        systolic: e.target.value,
                      })
                    }
                  />
                  <span className="text-green fw-bold">/</span>
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={bloodPressure?.diastolic}
                    onChange={(e) =>
                      setBloodPressure({
                        ...bloodPressure,
                        diastolic: e.target.value,
                      })
                    }
                  />
                  <span className="text-green fw-bold">mmHg</span>
                </div>
                <RateChart data={bloodPressureHistory} />
                <div className="my-2 text-center ">
                  <div className="d-flex gap-4 align-items-center justify-content-center">
                    <div className="d-flex gap-2 align-items-center">
                      <span
                        style={{
                          width: "20px",
                          height: "8px",
                          backgroundColor: "#4CC2B0",
                          borderRadius: "30%",
                        }}
                      ></span>
                      <span>Systolic</span>
                    </div>
                    <div className="d-flex gap-2 align-items-center">
                      <span
                        style={{
                          width: "20px",
                          height: "8px",
                          backgroundColor: "#999B9C",
                          borderRadius: "30%",
                        }}
                      ></span>
                      <span>Diastolic</span>
                    </div>
                  </div>
                  <span className="text-green fw-bold">
                    Last 5 documented readings
                  </span>
                </div>
              </div>
              <div className="col-md-4 px-3">
                <h6 className=" text-muted mb-0">Respiratory</h6>
                <div className="d-flex gap-2 align-items-center my-2 ">
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={respiratory}
                    onChange={(e) => setRespiratory(e.target.value)}
                  />
                  <span className="text-green fw-bold">cycles/min</span>
                </div>
                <RateChart data={respiratoryHistory} />
                <div className="my-2 text-center ">
                  <span className="text-green fw-bold">
                    Last 5 documented readings
                  </span>
                </div>
              </div>
              <div className="col-md-4">
                <h6 className=" text-muted mb-0">Temperature</h6>
                <div className="d-flex gap-2 align-items-center my-2 ">
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={temperature}
                    onChange={(e) => setTemperature(e.target.value)}
                  />
                  <span className="text-green fw-bold">°F</span>
                </div>
                <RateChart data={temperatureHistory} />
                <div className="my-2 text-center ">
                  <span className="text-green fw-bold">
                    Last 5 documented readings
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="row justify-content-center">
              <div className="col-md-4 px-3">
                <h6 className=" text-muted mb-0">Oxygen Saturation</h6>
                <div className="d-flex gap-2 align-items-center my-2 ">
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={oxygenSaturation}
                    onChange={(e) => setOxygenSaturation(e.target.value)}
                  />
                  <span className="text-green fw-bold">%</span>
                </div>
                <RateChart data={oxygenSaturationHistory} />
                <div className="my-2 text-center ">
                  <span className="text-green fw-bold">
                    Last 5 documented readings
                  </span>
                </div>
              </div>
              <div className="col-md-4 px-3">
                <h6 className=" text-muted mb-0">Heart Rate</h6>
                <div className="d-flex gap-2 align-items-center my-2 ">
                  <input
                    type="text"
                    style={{ width: "50px" }}
                    className="form-control bg-light p-0 text-center"
                    value={heartRate}
                    onChange={(e) => setHeartRate(e.target.value)}
                  />
                  <span className="text-green fw-bold">beats/min</span>
                </div>
                <RateChart data={heartRateHistory} />
                <div className="my-2 text-center ">
                  <span className="text-green fw-bold">
                    Last 5 documented readings
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-2 pt-2">
            <div className="">
              <span className="" style={{ fontWeight: "500" }}>
                Other System Comments
              </span>
            </div>
            <div className="mt-2">
              <BulletEditor
                value={otherSystemComments}
                setValue={setOtherSystemComments}
              />
            </div>
          </div>
          <div className="mt-4">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Assessment</h6>
            </div>
            <div className="mt-3">
              <AsyncSelect
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "light",
                    padding: "0 0 0 0.25rem",
                    fontSize: "1rem",
                    fontWeight: "400",
                    lineHeight: "1.5",
                    color: "var(--bs-body-color)",
                    appearance: "none",
                    border:
                      "var(--bs-border-width) solid var(--bs-border-color)",
                    borderRadius: "var(--bs-border-radius)",
                    transition:
                      "border-color .15s ease-in-out, box-shadow .15s ease-in-out",
                  }),
                }}
                className="bg-light"
                placeholder="Select Assessment"
                defaultOptions={icdCodeList.map((item) => ({
                  label: item?.name,
                  value: item?.name,
                }))}
                loadOptions={async (inputValue) => {
                  const response = await getIcdCodes({ icdCode: inputValue });
                  const data = response.data.data;
                  return data.map((item) => ({
                    label: item.name,
                    value: item.name,
                  }));
                }}
                value={{
                  label: assessmentDiagnosis,
                  value: assessmentDiagnosis,
                }}
                onChange={(data) => {
                  console.log(data);
                  setAssessmentDiagnosis(data.value);
                }}
              ></AsyncSelect>
            </div>
            <div className="mt-2 pt-2">
              <div className="">
                <span className="" style={{ fontWeight: "500" }}>
                  Other Comments
                </span>
              </div>
              <div className="mt-2">
                <BulletEditor
                  value={assessmentComments}
                  setValue={setAssessmentComments}
                />
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="bg-green px-3 py-2">
              <h6 className="text-white mb-0 fw-bold">Plan</h6>
            </div>
            <div
              data-bs-toggle="modal"
              data-bs-target="#addCarePlanModal"
              className="d-flex justify-content-start gap-2 align-items-center pointer my-3"
              onClick={() => {}}
            >
              <FiPlusCircle color="#1F7E78" size={18} />
              <span href="" className="fst-italic" style={{ fontSize: "16px" }}>
                Add Care Plan
              </span>
            </div>

            <div className="mt-2">
              {carePlans.map((item, index) => (
                <div
                  className="d-flex gap-3 align-items-center mb-2"
                  key={index}
                >
                  <input
                    type="text"
                    className="form-control bg-light w-25"
                    value={item.name}
                    disabled
                  />
                  <div className="d-flex gap-1 align-items-center">
                    <button
                      className="btn btn-sm"
                      onClick={() => {
                        setEditCarePlan({ carePlan: item, index });
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#editCarePlanModal"
                    >
                      <AiFillEdit color="#1F7E78" size={18} />
                    </button>
                    <button
                      className="btn btn-sm"
                      onClick={() => handleDeleteCarePlan(index)}
                    >
                      <RiDeleteBin6Fill color="#1F7E78" size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-2 pt-2">
              <div className="">
                <span className="" style={{ fontWeight: "500" }}>
                  Other Comments
                </span>
              </div>
              <div className="mt-2">
                <BulletEditor
                  value={carePlanComments}
                  setValue={setCarePlanComments}
                />
              </div>
            </div>
          </div>
          <div className="mt-4 d-flex justify-content-between">
            <button
              className="btn border py-2"
              onClick={() => setViewMode("sessionNotes")}
            >
              Cancel
            </button>
            <div className="d-flex gap-2">
              <button
                className="btn btn-custom-tag mb-0 py-2"
                onClick={() => handleSubmit("saveLater")}
              >
                Save for Later
              </button>
              <button
                className="btn btn-custom text-white py-2"
                onClick={() => handleSubmit("saveSessionNote")}
              >
                Save Session Note
              </button>
            </div>
          </div>
        </div>
      )}
      <EditChiefComplaintModal
        editComplaint={editComplaint}
        handleEditChiefComplaint={handleEditChiefComplaint}
      />
      <AddChiefComplaintModal
        handleAddChiefComplaint={handleAddChiefComplaint}
      />
      <EditCarePlanModal
        editCarePlan={editCarePlan}
        handleEditCarePlan={handleEditCarePlan}
        carePlanList={carePlanList}
      />
      <AddCarePlanModal
        editCarePlan={editCarePlan}
        handleAddCarePlan={handleAddCarePlan}
        carePlanList={carePlanList}
      />
      <EditMedicalHistoryModal
        editMedicalHistory={editMedicalHistory}
        handleEditMedicalHistory={handleEditMedicalHistory}
      />
      <AddMedicalHistoryModal
        handleAddMedicalHistory={handleAddMedicalHistory}
      />
      <AddFamilySocialHistoryModal
        handleAddFamilySocialHistory={handleAddFamilySocialHistory}
      />
      <EditFamilySocialHistoryModal
        editFamilySocialHistory={editFamilySocialHistory}
        handleEditFamilySocialHistory={handleEditFamilySocialHistory}
      />
    </div>
  );
}

export default ViewSessionNoteEdit;
